import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';

@Component({
  selector: 'ipm-user-order-details',
  templateUrl: './user-order-details.component.html',
  styleUrls: ['./user-order-details.component.scss']
})
export class UserOrderDetailsComponent implements OnInit{
  @Input() data: any;
  constructor(private commonService: CommonService,
    public browserStorage : BrowserStorageService) { }

  ngOnInit(): void {
  }

    /** 
 * close Popover Function
 * @param event 
 */ 
 closePopOver(event:any) {
  if (event) {
    this.commonService.closePopUp();
  }
 }
}
